/**
 * The operator plane's GET routes, built on the same shape as `GET_ROUTES` but held here: the
 * ops bundle may not reach `src/app/`, and `GET_ROUTES` imports every tenant screen's schema.
 */

import { z } from 'zod';

import { free, type GetRoute } from '../../lib/http/routePath';
import {
  creditRequestSchema,
  inferenceTaskSchema,
  operationCatalogueRowSchema,
  operatorSpendRowSchema,
  opsKeySchema,
  opsMovementSchema,
  opsTenantDetailSchema,
  opsTenantRowSchema,
  platformAdminSchema,
  platformMarginSchema,
  postStatsSettingsSchema,
  privacyThresholdSchema,
} from './schemas';

export const OPS_GET_ROUTES = {
  opsTenants: free('/ops/tenants', z.array(opsTenantRowSchema)),
  opsTenant: free('/ops/tenants/$id', opsTenantDetailSchema),
  opsTenantMovements: free('/ops/tenants/$tenantId/credits/movements', z.array(opsMovementSchema)),
  opsOperations: free('/ops/operations', z.array(operationCatalogueRowSchema)),
  opsKeys: free('/ops/keys', z.array(opsKeySchema)),
  opsInference: free('/ops/inference', z.array(inferenceTaskSchema)),
  opsCreditRequests: free('/ops/credit-requests', z.array(creditRequestSchema)),
  opsUsage: free('/ops/usage', z.array(operatorSpendRowSchema)),
  opsTenantUsage: free('/ops/usage/tenants/$tenantId', z.array(operatorSpendRowSchema)),
  opsPlatformUsage: free('/ops/usage/platform', platformMarginSchema),
  opsAdmins: free('/ops/admins', z.array(platformAdminSchema)),
  opsPrivacyThresholds: free('/ops/privacy/thresholds', z.array(privacyThresholdSchema)),
  opsPostStats: free('/ops/collection/post-stats', postStatsSettingsSchema),
} as const satisfies Record<string, GetRoute>;
